











































import Vue from 'vue';

export default Vue.extend({
    model: {
        prop: 'checked',
        event: 'change',
    },
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        toggle() {
            this.$emit('change', !this.checked);
        },
    },
});
